module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/PinusPumila/Kanagawa_PinusPumila_MRI_RCP45_Now.png";